export const tableHeaders = [
  {
    id: 1,
    label: 'File',
    intlKey: 'table.file'
  },
  {
    id: 2,
    label: 'Title',
    intlKey: 'table.title'
  },
  {
    id: 3,
    label: 'Description',
    intlKey: 'table.description'
  },
  {
    id: 4,
    label: 'Date',
    intlKey: 'table.date'
  },
  {
    id: 5,
    label: 'Activity',
    intlKey: 'table.activity'
  },
  {
    id: 6,
    label: 'Is WWC',
    intlKey: 'table.is_wwc'
  },
  {
    id: 7,
    label: 'Action',
    intlKey: 'table.action'
  }
]
